/**
 * /frontend/src/features/analytics/hooks/useBottleneckAnalytics.js
 */

import { useCallback, useMemo } from 'react';
import { getBottleneckSections, getBottleneckZones } from '../api/bottleneckAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads bottleneck analytics data.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const useBottleneckAnalytics = (params = {}) => {
  const { request, storeToken, storeUuid, startDate, endDate, refreshSignal } = params;
  const enabled = Boolean(request && storeUuid);

  const fetcher = useCallback(async () => {
    const [sections, zones] = await Promise.all([
      getBottleneckSections(request, storeToken, storeUuid, startDate, endDate),
      getBottleneckZones(request, storeToken, storeUuid, startDate, endDate),
    ]);
    return { sections, zones };
  }, [endDate, request, startDate, storeToken, storeUuid]);

  const resource = useAnalyticsResource(enabled, fetcher, 'useBottleneckAnalytics', refreshSignal);
  return useMemo(() => resource, [resource]);
};

export default useBottleneckAnalytics;
